var $fbaaaaebd547d998$exports = {};
$fbaaaaebd547d998$exports = {
  "dragDescriptionKeyboard": "Pritisnite tipko Enter za za\u010Detek vle\u010Denja.",
  "dragDescriptionKeyboardAlt": "Pritisnite tipki Alt + Enter za za\u010Detek vle\u010Denja.",
  "dragDescriptionLongPress": "Pritisnite in zadr\u017Eite za za\u010Detek vle\u010Denja.",
  "dragDescriptionTouch": "Dvotapnite za za\u010Detek vle\u010Denja.",
  "dragDescriptionVirtual": "Kliknite za za\u010Detek vle\u010Denja.",
  "dragItem": function dragItem(args) {
    return "Povleci ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Povlecite ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izbran element");
      },
      other: function other() {
        return "izbrane elemente (".concat(formatter.number(args.count), ")");
      }
    }));
  },
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Pritisnite tipko Enter, da povle\u010Dete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izbrani element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izbranih elementov");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Pritisnite tipki Alt + Enter, da povle\u010Dete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izbrani element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izbranih elementov");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Pritisnite in zadr\u017Eite, da povle\u010Dete ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " izbrani element");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " izbranih elementov");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Vle\u010Denje se je za\u010Delo. Pritisnite tipko Tab za pomik na mesto, kamor \u017Eelite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekli\u010Dete postopek.",
  "dragStartedTouch": "Vle\u010Denje se je za\u010Delo. Pomaknite se na mesto, kamor \u017Eelite spustiti elemente, in dvotapnite, da jih spustite.",
  "dragStartedVirtual": "Vle\u010Denje se je za\u010Delo. Pomaknite se na mesto, kamor \u017Eelite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.",
  "dropCanceled": "Spust je preklican.",
  "dropComplete": "Spust je kon\u010Dan.",
  "dropDescriptionKeyboard": "Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekli\u010Dete vle\u010Denje.",
  "dropDescriptionTouch": "Dvotapnite, da spustite.",
  "dropDescriptionVirtual": "Kliknite, da spustite.",
  "dropIndicator": "indikator spusta",
  "dropOnItem": function dropOnItem(args) {
    return "Spusti na mesto ".concat(args.itemText);
  },
  "dropOnRoot": "Spusti na mesto",
  "endDragKeyboard": "Vle\u010Denje. Pritisnite tipko Enter za preklic vle\u010Denja.",
  "endDragTouch": "Vle\u010Denje. Dvotapnite za preklic vle\u010Denja.",
  "endDragVirtual": "Vle\u010Denje. Kliknite, da prekli\u010Dete vle\u010Denje.",
  "insertAfter": function insertAfter(args) {
    return "Vstavi za ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Vstavi pred ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Vstavi med ".concat(args.beforeItemText, " in ").concat(args.afterItemText);
  }
};
export { $fbaaaaebd547d998$exports as default };